// @flow

import flattenDeep from 'lodash.flattendeep';

import type {TreeRowData} from '../typedef';

export const prepareTreeRowsSections = <DataRow>(
    treeRows: Array<TreeRowData<DataRow>>
): Array<Array<TreeRowData<DataRow>>> => (
        treeRows.map(item => {
            const arr = [item];

            if (item.expanded && item.children && Array.isArray(item.children)) {
                arr.push(...prepareTreeRowsSections(((item.children: any): Array<TreeRowData<DataRow>>)));
            }

            if (item.additionalRows && Array.isArray(item.additionalRows)) {
                const additionalRows = item.additionalRows.map(row => ({
                    ...row,
                    mainRow: false,
                    mainTotal: true
                }));
                arr.push(...additionalRows);
            }
            return flattenDeep(arr);
        })
    );

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
